import { NoValue as EmptyCell } from 'module/ui/components/atoms/no-value/empty-cell';

const removeTrailingZeroes = (amount: string) => amount.replace(/\.0+$/, '');

export const PercentageRenderer = ({
  value,
  precision = 2,
}: {
  value: number;
  precision?: number;
}) => {
  if (!value) {
    return <EmptyCell />;
  }

  return <>{removeTrailingZeroes(value.toFixed(precision))}%</>;
};
